const SignupModal = ({ onConfirm, onCancel }) => (<div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in-up">
    <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-[90vw] sm:max-w-md w-full">
        {/* Header */}
        <div className="text-center">
            <h3 className="mt-2 text-xl font-bold text-gray-800">VirdioHealth</h3>
            <p className="mt-2 text-sm text-gray-600">
                To create an account, you’ll need to complete the Guided Self-Assessment first. Would you like to start the assessment now, or stay on the Sign In screen?
            </p>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex flex-col gap-3">
            <button
                onClick={onConfirm}
                className="w-full px-4 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow-md transform hover:shadow-xl transition"
            >
                Goto Guided Self-Assessment
            </button>
            <button
                onClick={onCancel}
                className="w-full px-4 py-2 text-gray-700 font-semibold rounded-lg border border-gray-300 hover:bg-gray-100 transition"
            >
                Stay on Sign In Screen
            </button>
        </div>
		
    </div>
</div>
);

export default SignupModal;